import isEmpty from 'lodash/isEmpty';
import getGlobalStore from './getGlobalStore';

let state = {};
const getGlobalState = () => {
  if (isEmpty(state)) {
    const globalStore = getGlobalStore();
    if (globalStore) {
      state = globalStore.getState();
    }
  }
  return state;
};

export default getGlobalState;
